<template>
  <CircleColorPicker
    :model-value="modelValue"
    :extra-color-sets="extraColorSets"
    @update:model-value="(color, $event) => $emit('update:modelValue', color, $event)"
    data-test-id="code-color-picker-button"
    no-color-allowed
  />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { Color, Project } from '@/types';

export default defineComponent({
  name: 'CodeColorPicker',

  emits: { 'update:modelValue': null },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    project: {
      type: Object as PropType<Project>,
      required: true,
    },
  },
  computed: {
    extraColorSets(): Array<{ name: string; colors: Array<Color> }> {
      if (this.project.importedColors?.length) {
        return [
          {
            name: this.$t('projectImport.colors.title'),
            colors: this.project.importedColors,
          },
        ];
      }

      return [];
    },
  },
});
</script>

<style lang="scss">
.circle-color-picker {
  cursor: pointer;
}
</style>
